<app-carousel [typeSearch]="'Employee'"></app-carousel>

<div class="text-center my-3" *ngIf="isLoading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
  </div>  

<form class="body-app mt-3 mb-3" [formGroup]="jobForm" (ngSubmit)="submit()" *ngIf="!isLoading">
    <div class="content-app">
        <div class="row mt-5 mb-2">
            <div class="col-md-6 col-sm-6 col-12">
                <h5 class="mt-0 mb-2">
                    <i class="fa-solid fa-briefcase"></i>
                    Crear oferta de empleo
                </h5>
                <p class="text-muted small">Complete todos los campos para crear una oferta de empleo atractiva para los candidatos. Los campos marcados con <span class="required-field"></span> son obligatorios. </p>
            </div>
            <div class="col-md-6 col-sm-6 col-12"></div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="row">
            
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="form-group mb-3">
                    <label>Posición</label>
                    <div>
                        <app-dropdown [options]="positionList" formControlName="positionId"></app-dropdown>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="form-group mb-3">
                    <label class="required-field">Título del Puesto</label>
                    <div>
                        <input type="text" class="form-control" formControlName="title" />
                    </div>
                    <app-form-errors [controlName]="jobForm.controls['title']"></app-form-errors>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="form-group mb-3">
                    <label>Departamento</label>
                    <div>
                        <app-dropdown [options]="departmentList" formControlName="departmentId"></app-dropdown>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="form-group mb-3">
                    <label class="required-field">Tipo de contrato</label>
                    <div>
                        <app-dropdown [options]="contractTypeList" formControlName="contractTypeId" placeholder="Seleccionar tipo de contrato"></app-dropdown>
                    </div>
                    <app-form-errors [controlName]="jobForm.controls['contractTypeId']"></app-form-errors>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="form-group mb-3">
                    <label>Salario</label>
                    <div>
                        <input type="text" prefix="$" mask="separator.2" thousandSeparator="," class="form-control" formControlName="proposedSalary" />
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="form-group mb-3">
                    <label class="required-field">Estatus de la oferta</label>
                    <div>
                        <app-dropdown [options]="jobStatusList" formControlName="statusId" placeholder="Seleccionar estatus"></app-dropdown>
                    </div>
                    <app-form-errors [controlName]="jobForm.controls['statusId']"></app-form-errors>
                    <small class="text-muted mt-2 d-block">
                        <i class="fas fa-info-circle"></i> Nota: Las ofertas con estatus "Publicada" serán visibles para todos los candidatos de la plataforma.
                    </small>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-6 col-12">
                <div class="form-group mb-3">
                    <label>¿Ocultar nombre y logo de la empresa?</label>
                    <div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio"
                                formControlName="isPrivate" [value]="true" />
                            <label class="form-check-label">Si</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio"
                                formControlName="isPrivate" [value]="false" />
                            <label class="form-check-label">No</label>
                        </div>
                    </div>
                    <small class="text-muted mt-2 d-block">
                        <i class="fas fa-info-circle"></i> Nota: Si tienes activa en tu cuenta la opción de "Ocultar nombre de empresa y logo", automáticamente esta oferta laboral tendrá oculta el nombre y logo de la empresa.
                    </small>
                </div>
            </div>
        </div>
        
        <ul class="nav nav-tabs theme-tabs" id="tabcv" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link active" id="tabcv-01-tab" data-bs-toggle="tab"
                    data-bs-target="#tabcv-01-tab-pane" type="button" role="tab" aria-controls="tabcv-01-tab-pane"
                    aria-selected="true">
                    <i class="fa-solid fa-briefcase"></i>
                    Detalles de la vacante
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" id="tabcv-02-tab" data-bs-toggle="tab" data-bs-target="#tabcv-02-tab-pane"
                    type="button" role="tab" aria-controls="tabcv-02-tab-pane" aria-selected="false">
                    <i class="fa-solid fa-user-tie"></i>
                    Requisitos del Candidato
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" id="tabcv-03-tab" data-bs-toggle="tab" data-bs-target="#tabcv-03-tab-pane"
                    type="button" role="tab" aria-controls="tabcv-03-tab-pane" aria-selected="false">
                    <i class="fa-regular fa-address-book"></i>
                    Información de contacto
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" id="tabcv-04-tab" data-bs-toggle="tab" data-bs-target="#tabcv-04-tab-pane"
                    type="button" role="tab" aria-controls="tabcv-04-tab-pane" aria-selected="false" tabcv-04>
                    <i class="fa-solid fa-location-dot"></i>
                    Duración y ubicación
                </button>
            </li>
        </ul>
        <div class="tab-content" id="tabcvContent">
            <div class="tab-pane fade show active" id="tabcv-01-tab-pane" role="tabpanel" aria-labelledby="tabcv-01-tab"
                tabindex="0">
                <div class="card">
                    <div class="card-body">
                        <h5 class="mt-0 mb-2">
                            <i class="fa-regular fa-file-lines"></i>
                            Detalle
                        </h5>
                        <p class="text-muted small mb-3"> En esta sección debe proporcionar información detallada sobre la vacante, incluyendo descripción del puesto, responsabilidades, requisitos específicos, beneficios ofrecidos e idiomas necesarios.</p>
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <div class="form-group mb-3">
                                    <label class="required-field">Descripción del puesto</label>
                                    <div>
                                        <textarea class="form-control" rows="5"
                                            formControlName="description"></textarea>
                                    </div>
                                    <app-form-errors [controlName]="jobForm.controls['description']"></app-form-errors>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <div class="form-group mb-3">
                                    <label>Responsabilidades y tareas</label>
                                    <div>
                                        <textarea class="form-control" rows="5"
                                            formControlName="responsabilities"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <div class="form-group mb-3">
                                    <label>Requisitos del puesto</label>
                                    <div class="input-group">
                                        <app-dropdown [options]="requirementList" formControlName="selectedRequirementId" placeholder="Seleccionar requisito"></app-dropdown>
                                        <button type="button" class="btn btn-success" (click)="addRequirementFromSelect()" *ngIf="viewType != viewEnums.View">
                                            <i class="fa-solid fa-circle-plus"></i>
                                            Agregar
                                        </button>
                                    </div>
                                </div>
                                <div class="card shadow-sm border-0 mb-3">
                                    <div class="card-header bg-light py-2 d-flex justify-content-between align-items-center">
                                        <h6 class="mb-0 fw-bold">Requisitos agregados</h6>
                                        <span class="badge bg-primary rounded-pill">{{requirementsList.controls.length}}</span>
                                    </div>
                                    <div class="table-container" style="max-height: 300px; overflow-y: auto;">
                                        <table class="table table-hover mb-0">
                                            <thead class="sticky-top">
                                                <tr>
                                                    <th style="background: #0d1174; color: #fff;">Requisito</th>
                                                    <th width="50px" class="text-center" style="background: #0d1174; color: #fff;"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngFor="let control of requirementsList.controls; let i = index">
                                                    <tr *ngIf="control.value.isEnabled">
                                                        <td>{{ control.value.name }}</td>
                                                        <td class="text-center">
                                                            <button
                                                                type="button"
                                                                class="btn btn-danger btn-sm rounded-circle"
                                                                (click)="removeRequirement(i)" *ngIf="viewType != viewEnums.View"
                                                                title="Eliminar requisito"
                                                            >
                                                                <i class="fa-regular fa-trash-can"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                                <tr *ngIf="requirementsList.controls.length === 0">
                                                    <td colspan="2" class="text-center text-muted py-3">No hay requisitos agregados</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <div class="form-group mb-3">
                                    <label>Beneficios</label>
                                    <div class="input-group">
                                        <app-dropdown [options]="benefitList" formControlName="selectedBenefitId" placeholder="Seleccionar beneficio"></app-dropdown>
                                        <button type="button" class="btn btn-success" (click)="addBenefitFromSelect()" *ngIf="viewType != viewEnums.View">
                                            <i class="fa-solid fa-circle-plus"></i>
                                            Agregar
                                        </button>
                                    </div>
                                </div>
                                <div class="card shadow-sm border-0 mb-3">
                                    <div class="card-header bg-light py-2 d-flex justify-content-between align-items-center">
                                        <h6 class="mb-0 fw-bold">Beneficios agregados</h6>
                                        <span class="badge bg-primary rounded-pill">{{benefitsList.controls.length}}</span>
                                    </div>
                                    <div class="table-container" style="max-height: 300px; overflow-y: auto;">
                                        <table class="table table-hover mb-0">
                                            <thead class="sticky-top">
                                                <tr>
                                                    <th style="background: #0d1174; color: #fff;">Beneficio</th>
                                                    <th width="50px" class="text-center" style="background: #0d1174; color: #fff;"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngFor="let control of benefitsList.controls; let i = index">
                                                    <tr *ngIf="control.value.isEnabled">
                                                        <td>{{ control.value.name }}</td>
                                                        <td class="text-center">
                                                            <button
                                                                type="button"
                                                                class="btn btn-danger btn-sm rounded-circle"
                                                                (click)="removeBenefit(i)" *ngIf="viewType != viewEnums.View"
                                                                title="Eliminar beneficio"
                                                            >
                                                                <i class="fa-regular fa-trash-can"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                                <tr *ngIf="benefitsList.controls.length === 0">
                                                    <td colspan="2" class="text-center text-muted py-3">No hay beneficios agregados</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <div class="form-group mb-3">
                                    <label>Idiomas necesarios</label>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <app-dropdown [options]="languageList" formControlName="selectedLanguageId" placeholder="Seleccione un idioma" class="mb-2"></app-dropdown>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="input-group">
                                                <app-dropdown [options]="languageLevelList" formControlName="selectedLanguageLevelId" placeholder="Seleccione un nivel"></app-dropdown>
                                                <button type="button" class="btn btn-success" (click)="addLanguageFromSelect()" *ngIf="viewType != viewEnums.View">
                                                    <i class="fa-solid fa-circle-plus"></i>
                                                    Agregar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card shadow-sm border-0 mb-3">
                                    <div class="card-header bg-light py-2 d-flex justify-content-between align-items-center">
                                        <h6 class="mb-0 fw-bold">Idiomas requeridos</h6>
                                        <span class="badge bg-primary rounded-pill">{{requiredLanguages.controls.length}}</span>
                                    </div>
                                    <div class="table-container" style="max-height: 300px; overflow-y: auto;">
                                        <table class="table table-hover mb-0">
                                            <thead class="sticky-top">
                                                <tr>
                                                    <th style="background: #0d1174; color: #fff;">Idioma</th>
                                                    <th style="background: #0d1174; color: #fff;">Nivel</th>
                                                    <th width="50px" class="text-center" style="background: #0d1174; color: #fff;"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngFor="let control of requiredLanguages.controls; let i = index">
                                                    <tr *ngIf="control.value.isEnabled">
                                                        <td>{{ control.value.name }}</td>
                                                        <td>{{ control.value.levelName }}</td>
                                                        <td class="text-center">
                                                            <button
                                                                type="button"
                                                                class="btn btn-danger btn-sm rounded-circle"
                                                                (click)="removeLanguage(i)" *ngIf="viewType != viewEnums.View"
                                                                title="Eliminar idioma"
                                                            >
                                                                <i class="fa-regular fa-trash-can"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                                <tr *ngIf="requiredLanguages.controls.length === 0">
                                                    <td colspan="3" class="text-center text-muted py-3">No hay idiomas agregados</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <div class="form-group mb-3">
                                    <label>Disponibilidad para Viajar</label>
                                    <div>
                                        <div class="form-check form-check-inline" *ngFor="let dispo of travelDisponibilities">
                                            <input class="form-check-input" type="radio"
                                                formControlName="travelDisponibilityId" [value]="dispo.id" id="radio-{{dispo.id}}" />
                                            <label class="form-check-label">{{dispo.text}}</label>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="form-group mb-3">
                                    <label>Permiso de Trabajo</label>
                                    <div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio"
                                                formControlName="needEmploymentAuthorization" [value]="true" />
                                            <label class="form-check-label">Si</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio"
                                                formControlName="needEmploymentAuthorization" [value]="false" />
                                            <label class="form-check-label">No</label>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="tabcv-02-tab-pane" role="tabpanel" aria-labelledby="tabcv-02-tab"
                tabindex="0">
                <div class="card">
                    <div class="card-body">
                        <h5 class="mt-0 mb-2">
                            <i class="fa-solid fa-list-check"></i>
                            Requisitos
                        </h5>
                        <p class="text-muted small mb-3"> Especifique los requisitos que debe cumplir el candidato ideal para esta vacante. Incluya nivel educativo, experiencia laboral, habilidades específicas y certificaciones necesarias para desempeñar el puesto correctamente.</p>
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <div class="form-group mb-3">
                                    <label>Nivel de educación requerido</label>
                                    <div>
                                        <app-dropdown [options]="educationLevelList" formControlName="educationLevelId" placeholder="Seleccionar nivel de educación"></app-dropdown>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <div class="form-group mb-3">
                                    <label>Experiencia laboral</label>
                                    <div>
                                        <app-dropdown [options]="workExperienceLevelList" formControlName="workExperienceLevelId" placeholder="Seleccionar experiencia laboral"></app-dropdown>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <div class="form-group mb-3">
                                    <label>Habilidades requeridas</label>
                                    <div class="input-group">
                                        <app-dropdown [options]="skillList" formControlName="selectedSkillId" placeholder="Seleccionar habilidad"></app-dropdown>
                                        <button type="button" class="btn btn-success" (click)="addSkillFromSelect()" *ngIf="viewType != viewEnums.View">
                                            <i class="fa-solid fa-circle-plus"></i>
                                            Agregar
                                        </button>
                                    </div>
                                </div>
                                <div class="card shadow-sm border-0 mb-3">
                                    <div class="card-header bg-light py-2 d-flex justify-content-between align-items-center">
                                        <h6 class="mb-0 fw-bold">Habilidades agregadas</h6>
                                        <span class="badge bg-primary rounded-pill">{{skills.controls.length}}</span>
                                    </div>
                                    <div class="table-container" style="max-height: 300px; overflow-y: auto;">
                                        <table class="table table-hover mb-0">
                                            <thead class="sticky-top">
                                                <tr>
                                                    <th style="background: #0d1174; color: #fff;">Habilidad</th>
                                                    <th width="50px" class="text-center" style="background: #0d1174; color: #fff;"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngFor="let control of skills.controls; let i = index">
                                                    <tr *ngIf="control.value.isEnabled">
                                                        <td>{{ control.value.name }}</td>
                                                        <td class="text-center">
                                                            <button
                                                                type="button"
                                                                class="btn btn-danger btn-sm rounded-circle"
                                                                (click)="removeSkill(i)" *ngIf="viewType != viewEnums.View"
                                                                title="Eliminar habilidad"
                                                            >
                                                                <i class="fa-regular fa-trash-can"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                                <tr *ngIf="skills.controls.length === 0">
                                                    <td colspan="2" class="text-center text-muted py-3">No hay habilidades agregadas</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <div class="form-group mb-3">
                                    <label>Certificaciones necesarias</label>
                                    <div class="input-group">
                                        <app-dropdown [options]="certificationList" formControlName="selectedCertificationId" placeholder="Seleccionar certificación"></app-dropdown>
                                        <button type="button" class="btn btn-success" *ngIf="viewType != viewEnums.View"
                                            (click)="addCertificationFromSelect()">
                                            <i class="fa-solid fa-circle-plus"></i>
                                            Agregar
                                        </button>
                                    </div>
                                </div>
                                <div class="card shadow-sm border-0 mb-3">
                                    <div class="card-header bg-light py-2 d-flex justify-content-between align-items-center">
                                        <h6 class="mb-0 fw-bold">Certificaciones agregadas</h6>
                                        <span class="badge bg-primary rounded-pill">{{certifications.controls.length}}</span>
                                    </div>
                                    <div class="table-container" style="max-height: 300px; overflow-y: auto;">
                                        <table class="table table-hover mb-0">
                                            <thead class="sticky-top">
                                                <tr>
                                                    <th style="background: #0d1174; color: #fff;">Certificación</th>
                                                    <th width="50px" class="text-center" style="background: #0d1174; color: #fff;"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngFor="let control of certifications.controls; let i = index">
                                                    <tr *ngIf="control.value.isEnabled">
                                                        <td>{{ control.value.name }}</td>
                                                        <td class="text-center">
                                                            <button
                                                                type="button"
                                                                class="btn btn-danger btn-sm rounded-circle"
                                                                (click)="removeCertification(i)" *ngIf="viewType != viewEnums.View"
                                                                title="Eliminar certificación"
                                                            >
                                                                <i class="fa-regular fa-trash-can"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                                <tr *ngIf="certifications.controls.length === 0">
                                                    <td colspan="2" class="text-center text-muted py-3">No hay certificaciones agregadas</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="tabcv-03-tab-pane" role="tabpanel" aria-labelledby="tabcv-03-tab"
                tabindex="0">
                <div class="card">
                    <div class="card-body">
                        <h5 class="mt-0 mb-2">
                            <i class="fa-solid fa-mobile-screen-button"></i>
                            Datos del contacto
                        </h5>
                        <p class="text-muted small mb-3"> Proporcione la información de contacto para esta oferta laboral. Estos datos serán utilizados por los candidatos para comunicarse o enviar su aplicación según el método seleccionado.</p>
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group mb-3">
                                    <label>Nombre de la persona</label>
                                    <div>
                                        <input type="text" class="form-control" formControlName="contactInfoName" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group mb-3">
                                    <label>Correo electrónico</label>
                                    <div>
                                        <input type="text" class="form-control" formControlName="contactInfoEmail" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group mb-3">
                                    <label>Número de teléfono</label>
                                    <div>
                                        <input type="text" class="form-control" formControlName="contactInfoPhone" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group mb-3">
                                    <label>Método de aplicación</label>
                                    <div>
                                        <app-dropdown [options]="jobApplicationMethodList" formControlName="jobApplicationMethodId" placeholder="Seleccionar método de aplicación"></app-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="tabcv-04-tab-pane" role="tabpanel" aria-labelledby="tabcv-04-tab"
                tabindex="0">
                <div class="card">
                    <div class="card-body">
                        <h5 class="mt-0 mb-2">
                            <i class="fa-solid fa-briefcase"></i>
                            Duración y modalidad
                        </h5>
                        <p class="text-muted small mb-3"> Especifique la duración del contrato y la posibilidad de trabajo remoto para esta vacante.</p>
                        <div class="row mb-4">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group mb-3">
                                    <label>Duración del contrato</label>
                                    <div>
                                        <app-dropdown [options]="jobDurationLevelList" formControlName="contractDurationId" placeholder="Seleccionar duración"></app-dropdown>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group mb-3">
                                    <label>Posibilidad de trabajo remoto</label>
                                    <div>
                                        <app-dropdown [options]="remoteWorkPossibilities" formControlName="remoteWorkPossibilityId" placeholder="Seleccionar posibilidad de trabajo remoto"></app-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h5 class="mt-0 mb-2">
                            <i class="fa-regular fa-calendar"></i>
                            Fechas de la oferta
                        </h5>
                        <p class="text-muted small mb-3"> Establezca las fechas de publicación y cierre de la oferta laboral. Si establece una fecha de publicación, la oferta será visible al público a partir de esa fecha. Si establece una fecha de cierre, la oferta dejará de estar visible al público en esa fecha.</p>
                        <div class="row mb-2">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group mb-3">
                                    <label>Fecha de publicación</label>
                                    <div>
                                        <input type="date" class="form-control" formControlName="publicOn" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group mb-3">
                                    <label>Fecha de cierre de la aplicación</label>
                                    <div>
                                        <input type="date" class="form-control" formControlName="closeOn" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h5 class="mt-2 mb-2">
                            <i class="fa-solid fa-location-dot"></i>
                            Ubicación del trabajo
                        </h5>
                        <p class="text-muted small mb-3"> Indique la ubicación física donde se desarrollará el trabajo o si existe la posibilidad de trabajo remoto. Esta información es crucial para que los candidatos evalúen si la ubicación es conveniente para ellos.</p>
                        <div class="row">
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group mb-3">
                                    <label>Dirección del lugar de trabajo</label>
                                    <div>
                                        <input type="text" class="form-control" formControlName="address" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group mb-3">
                                    <label>País</label>
                                    <div>
                                        <app-dropdown [options]="countryList" formControlName="countryId" placeholder="Seleccionar país" (ngModelChange)="onChangeCountry()"></app-dropdown>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group mb-3">
                                    <label>Estado / provincia</label>
                                    <div>
                                        <app-dropdown [options]="stateList" formControlName="stateId" placeholder="Seleccionar estado/provincia" (ngModelChange)="onChangeState()"></app-dropdown>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div class="form-group mb-3">
                                    <label>Ciudad</label>
                                    <div>
                                        <app-dropdown [options]="cityList" formControlName="cityId" placeholder="Seleccionar ciudad"></app-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr class="mt-3 mb-3" />
        <div class="mt-2 mb-2 text-end">
            <button type="button" class="btn btn-secondary me-2" (click)="onCancel()" [disabled]="isLoading || isSaving">
                Cancelar
            </button>
            <button type="submit" class="btn btn-primary" *ngIf="viewType != viewEnums.View" [disabled]="isLoading || isSaving">
                <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                {{ isSaving ? 'Guardando...' : 'Guardar' }}
            </button>
        </div>
    </div>
</form>